"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.gridSubheaderPlugin = void 0;
const react_1 = __importDefault(require("react"));
const Subheader_1 = require("./components/Subheader/Subheader");
function gridSubheaderPlugin(config) {
    return () => {
        return {
            subheaderAddons: [
                {
                    id: 'subheader',
                    render: () => react_1.default.createElement(Subheader_1.Subheader, null, config.content)
                }
            ]
        };
    };
}
exports.gridSubheaderPlugin = gridSubheaderPlugin;
//# sourceMappingURL=gridSubheaderPlugin.js.map